import { XCircleIcon } from '@heroicons/react/16/solid';
import { WrenchIcon } from '@heroicons/react/20/solid';

import { Typography } from 'src/shared/components/ui';

import {
  STAGE_ICONS_SMALL,
  STAGE_LABELS
} from '../../constants/samplingTimeline';

interface SampleStageProps {
  stage: string;
  /** Typography variant for the label; table cells use body-2, detail views body-1. */
  variant?: 'body-1' | 'body-2';
}

const SampleStage: React.FC<SampleStageProps> = ({
  stage,
  variant = 'body-1'
}) => {
  return (
    <div className="flex items-center gap-1">
      {stage?.includes('rejected') ? (
        <XCircleIcon className="text-danger size-4" />
      ) : (
        STAGE_ICONS_SMALL[stage] || <WrenchIcon className="w-4 h-4" />
      )}
      <Typography variant={variant} className="capitalize">
        {STAGE_LABELS[stage] ?? stage}
      </Typography>
    </div>
  );
};

export default SampleStage;
